import script from "./ThreadDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreadDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ThreadDetailView.vue?vue&type=style&index=0&id=4a0e23d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0e23d4"]])

export default __exports__